/***************************************************************
 * Responsibility - Shows the modal to approve a single proof 🐺
 * *************************************************************
 * @format */

import {Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import {useProofingContext} from '../proofing_context_provider';
import {DESIGN_STATUS_APPROVED} from 'frontier-constants';
import React, {useState, useEffect} from 'react';
import {IfElse} from 'frontier-utilities';
import {DESIGN_STATUS_NOT_REVIEWED} from '../../../../utilities/constants';

export const ApproveSingleModal = props => {
    const proofingCtx = useProofingContext();

    const {designOrder, onApprove, children} = props;

    const {lastDesignToReviewId, isSubmitting} = proofingCtx.data;
    const {handleDesignReview, complete} = proofingCtx;
    const designOrderId = designOrder.id;

    const [trackDesignTrigger, setTrackDesignTrigger] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const isThisLastDesignToReview = Number(lastDesignToReviewId) === Number(designOrder.id);

    const childWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                // only the last design to review should trigger the approve modal
                onClick: isThisLastDesignToReview
                    ? () => setIsOpen(true)
                    : handleTriggerDesignReview
            });
        }
        return child;
    });

    function handleTriggerDesignReview() {
        handleDesignReview(designOrderId, DESIGN_STATUS_APPROVED);
        setTrackDesignTrigger(trackDesignTrigger + 1);
        if (!isThisLastDesignToReview) onApprove();
    }

    // if this is the last design to review, we need to wait until the
    // review is complete to trigger the approve toast
    useEffect(() => {
        if (isThisLastDesignToReview) {
            if (complete > 0 && !isSubmitting) {
                onApprove();
            }
        }
    }, [complete, isSubmitting, trackDesignTrigger]);

    return (
        <>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} bodyHeightAuto>
                <ModalHeader>Approve Artwork</ModalHeader>
                <div className="px-0 py-3">
                    <p className="approve-modal-23ll__p m-0">
                        By clicking the Approve button below, you agree that you have read all
                        comments / notes, reviewed all artwork, and are approving the designs for
                        printing.
                    </p>
                </div>
                <ModalFooter>
                    <IfElse condition={isSubmitting}>
                        <div className="d-flex align-items-center justify-content-end">
                            <button className="btn btn-disabled bg-structure-dark color-structure-darkest">
                                <b>Submitting your proof...</b>
                            </button>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-4">
                            <button onClick={() => setIsOpen(false)} className="btn btn--secondary">
                                <b>Cancel</b>
                            </button>
                            <button
                                onClick={handleTriggerDesignReview}
                                className="btn btn--primary">
                                <b>Approve Artwork</b>
                            </button>
                        </div>
                    </IfElse>
                </ModalFooter>
            </Modal>
            <IfElse condition={!!children}>
                <>{childWithProps}</>
                <button>Approve</button>
            </IfElse>
        </>
    );
};
